import { BaseDto } from '../base.dto';
import { InvoiceOriginEnum } from '../../enum/invoice-origin.enum';
import { InvoiceBillingItemDto } from './invoice-billing-item.dto';
import { InvoiceFrequencyEnum } from '../../enum/invoice-frequency.enum';
import { InvoiceBillingDispatchLogDto } from './invoice-billing-dispatch-log.dto';
import { InvoiceStatusDto } from '../invoiceStatus.dto';

export class InvoiceBillingDto extends BaseDto {
  invoiceNumber: string;
  invoiceName: string;
  invoiceType: string;
  invoiceOrigin: InvoiceOriginEnum;
  invoiceFrequency: InvoiceFrequencyEnum;
  pieMerchantBusinessEntityId: number;
  invoiceToName: string;
  invoiceToAddress?: string;
  invoiceToVatNumber?: string;
  invoiceToEmail?: string;
  invoiceFromName: string;
  invoiceFromAddress: string;
  invoiceFromVatNumber: string;
  invoiceFromEmail: string;
  pieCurrencyId: number;
  invoiceCurrencyCode: string;
  billingStartDate: string; // Expects a string like "2025-07-14"
  invoiceDueDate: string; // Expects a string like "2025-07-14"
  invoiceStatusId: number;
  invoiceVatAmount: number;
  invoiceSubTotal: number;
  invoiceTotal: number;
  invoiceNote?: string;
  invoicePaymentLink?: string;
  invoiceWebPaymentCode: string;
  queueForDispatch?: boolean;
  invoiceItems?: InvoiceBillingItemDto[];
  invoiceStatus?: InvoiceStatusDto;
  invoiceDispatchLog?: InvoiceBillingDispatchLogDto;
}